/**
 * 硬件外设接口
 */

import instance from '@/utils/axios';

/**
 * 查询或者设置外设状态
 * @param {设备号} sn
 * @param {业务类型} busiType 9-查询状态，0-关闭，1-开启
 * @param {外设类型} peripheralType 1-滤毒罐， 2-生物采集器
 */
export function periphState(sn, busiType, peripheralType) {
  return instance('/hwperipheral/state', {
    params: {
      sn,
      busiType,
      peripheralType
    }
  });
}

/**
 * 查询或者设置外设状态
 * @param {设备号} sn
 * @param {外设类型} peripheralType 1-滤毒罐， 2-生物采集器
 */
export function periphInfo(sn, peripheralType) {
  return instance('/hwperipheral/info', {
    params: {
      sn,
      peripheralType
    }
  });
}
